"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _popover = require("../../constants/popover");

var _LinkPopoverControls = _interopRequireDefault(require("./LinkPopoverControls"));

var _iterables = require("../../utils/iterables");

/**
 * @TODO Remove this once `useContextualToolbar` is fully ungated
 */
var InsertLinkPopoverBody = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(InsertLinkPopoverBody, _Component);

  function InsertLinkPopoverBody() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, InsertLinkPopoverBody);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(InsertLinkPopoverBody)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.handleCloseOnKeyDown = function (evt) {
      if (evt.key === _popover.KeyTypes.ESCAPE) {
        _this.props.onClose();
      }
    };

    return _this;
  }

  (0, _createClass2.default)(InsertLinkPopoverBody, [{
    key: "render",
    value: function render() {
      var controlProps = (0, _iterables.pick)(Object.keys(_LinkPopoverControls.default.propTypes), this.props);
      return _react.default.createElement("div", {
        className: "p-x-5 p-y-3",
        onKeyDown: this.handleCloseOnKeyDown,
        tabIndex: "-1"
      }, _react.default.createElement(_LinkPopoverControls.default, Object.assign({}, controlProps, {
        popoverType: _popover.PopoverType.INSERT,
        onSubmit: this.props.onInsert
      })));
    }
  }]);
  return InsertLinkPopoverBody;
}(_react.Component);

exports.default = InsertLinkPopoverBody;
InsertLinkPopoverBody.propTypes = Object.assign({}, _LinkPopoverControls.default.propTypes, {
  onInsert: _propTypes.default.func.isRequired
});
module.exports = exports.default;